import NewApplicantPageContent from './components/NewApplicantPageContent'
import NewOnboarding from './components/NewOnboarding'

const NewApplicantPage = () => <NewOnboarding />
// const NewApplicantPage = () => <NewApplicantPageContent />

export default NewApplicantPage